import { post } from "../../../js/http";
import Cookies from "js-cookie";
import storage from "good-storage";

export function bindPop() {
  layer.open({
    type: 1,
    skin: "layer-custom",
    area: ["500px", ""],
    title: "",
    id: "bindPhoneCon",
    closeBtn: 2,
    content: $("#bindPhone-con"),
    end: function () {
      $("#bindPhone-con").hide();
      $("#setNewPhone").val("");
      $("#setTextCode").val("");
      $("#getVerBtn").text("获取验证码").removeAttr("disabled");
      $("#getVerBtn").css({
        color: "#FF5379",
      });
      clearInterval(countDown);
    },
  });
  $("#confirmBind").off("click");
  $("#confirmBind").click(function () {
    if (!$("#setNewPhone").val()) {
      layer.msg("请输入手机号", { icon: 2 });
      return;
    }
    if (!$("#setTextCode").val()) {
      layer.msg("请输入6位短信验证码", { icon: 2 });
      return;
    }
    if (
      md5($("#setTextCode").val()).toUpperCase() !=
      Cookies.get("bindPhoneMsgContent")
    ) {
      layer.msg("短信验证码不正确", { icon: 2 });
      return;
    }
    // 绑定手机号
    post("/ApiHome/ApiAction?_ControlName=OtherAccountBindingByPC", {
      UserID: storage.get("userInfo").UserID,
      LoginType: 2,
      UnionID: $("#setNewPhone").val(),
    }).then((res) => {
      if (res.ReturnStatus) {
        layer.msg(res.MessageCN, { icon: 1 });
        registerCodeTimer();
        setTimeout(() => {
          location.reload();
        });
      } else {
        layer.msg(res.MessageCN, { icon: 2 });
      }
    });
  });
}

let count;
let countDown = "";
//获取验证码按钮

function registerCodeTimer() {
  count = 60;
  doLoop();
  countDown = setInterval(doLoop, 1000);
}

function doLoop() {
  if (count > 0) {
    $("#getVerBtn").attr("disabled", true);
    $("#getVerBtn").css({
      color: "#999",
    });
    $("#getVerBtn").text(count + "S重发");
  } else {
    $("#getVerBtn").text("重新发送").removeAttr("disabled");
    $("#getVerBtn").css({
      color: "#FF5379",
    });
    clearInterval(countDown);
  }
  count--;
}

export function verCon() {
  layui.use(["layer", "form"], function () {
    var $ = layui.jquery,
      layer = layui.layer,
      form = layui.form;
    $("#getVerBtn").off("click");
    $("#getVerBtn").click(function () {
      var canvasCon;
      if ($("#setNewPhone").val().length == 11) {
        $("#imgVer").slideVerify({
          type: 2, //类型
          vOffset: 5, //误差量，根据需求自行调整
          vSpace: 5, //间隔
          // imgUrl: "https://picsum.photos/400/200?",
          // imgUrl: "https://uploadbeta.com/api/pictures/random?w=400&h=240&",
          // imgName: ["random=1", "random=2", "random=3"],
          imgUrl: "https://r.51callme.com/www/images/CAPTCHA/",
          imgName: [
            "1.jpg",
            "2.jpg",
            "3.jpg",
            "4.jpg",
            "5.jpg",
            "6.jpg",
            "7.jpg",
            "8.jpg",
            "9.jpg",
          ],
          imgSize: {
            width: "400px",
            height: "200px",
          },
          blockSize: {
            width: "40px",
            height: "40px",
          },
          barSize: {
            width: "400px",
            height: "40px",
          },
          ready: function () {},
          success: function () {
            layer.close(canvasCon);
            //从后台获取验证码
            getVerCode();
          },
          error: function () {
            console.log("验证失败！");
          },
        });
        canvasCon = layer.open({
          type: 1,
          skin: "layer-custom",
          area: ["440px", ""],
          title: "",
          id: "verBoxCon",
          closeBtn: 2,
          content: $("#verBox"),
          end: function () {
            $("#verBox").hide();
            $("#imgVer").empty();
          },
        });
        function getVerCode() {
          post("/ApiHome/ApiAction?_ControlName=SendPhoneCheckMessageByPC", {
            PhoneNumber: $("#setNewPhone").val(),
          }).then((res) => {
            if (res.ReturnStatus) {
              layer.msg(res.MessageCN, { icon: 1 });
              //加密后的短信验证码
              setCookies(
                "bindPhoneMsgContent",
                res.Data.MessageContent,
                30 * 60
              );
              registerCodeTimer();
            }
          });
        }
      } else {
        layer.msg("请输入手机号");
      }
    });
  });
}

//设置保存cookies时间
function setCookies(key, value, expiresTime) {
  let seconds = expiresTime;
  let expires = new Date(new Date() * 1 + seconds * 1000);
  return Cookies.set(key, value, { expires: expires });
}
